import { StyleSheet, View } from '@react-pdf/renderer';

import { Td } from '../../../../components/PdfExportV2/Td/Td.tsx';
import { Text } from '../../../../components/PdfExportV2/Text/Text.tsx';
import { Tr } from '../../../../components/PdfExportV2/Tr/Tr.tsx';
import { ExportCostApproachCostRow } from './ExportCostApproachCostRow.tsx';
import { ExportCostApproachDepreciationRows } from './ExportCostApproachDepreciationRows.tsx';
import { ExportCostApproachRollupRow } from './ExportCostApproachRollupRow.tsx';
import { textStyleOverrides } from './consts.ts';
import { ExportCostApproachData } from './types.ts';
import { makeColSpan } from './utils/makeColSpan.ts';

const styles = StyleSheet.create({
  tableContainer: {
    display: 'flex',
    flexDirection: 'column',
    width: '600px',
  },
});

export const ExportCostApproachTable = ({
  data,
  hasExternalDepreciation,
  hasFunctionalDepreciation,
}: {
  data: ExportCostApproachData;
  hasExternalDepreciation: boolean;
  hasFunctionalDepreciation: boolean;
}) => (
  <View style={styles.tableContainer}>
    <Tr>
      <Td style={{ width: makeColSpan(0, 1), border: 'none' }}>
        <Text variant="body1" {...textStyleOverrides}>
          Feature
        </Text>
      </Td>
      <Td style={{ width: makeColSpan(0, 1), border: 'none' }}>
        <Text variant="body1" {...textStyleOverrides}>
          Cost Data
        </Text>
      </Td>
    </Tr>
    <ExportCostApproachRollupRow
      label="Opinion Of Site Value"
      value={data.opinionOfSiteValuePrice ? data.opinionOfSiteValuePrice?.toString(true) : ''}
      isFirstRow
      isBold
    />
    <ExportCostApproachCostRow
      label="Dwelling"
      area={data.improvementsGla}
      cost={data.dwellingCostNew}
    />
    <ExportCostApproachCostRow
      label="Basement"
      area={data.improvementsBasement}
      cost={data.basementTotalCost}
    />
    <ExportCostApproachRollupRow
      label="Additional Structures"
      value={data.additionalStructureCostNew?.toString(true) ?? ''}
    />
    <ExportCostApproachCostRow
      label="Carport / Garage"
      area={data.improvementsGarageCarport}
      cost={data.garageCost}
    />
    <ExportCostApproachRollupRow
      label="Total Estimate Cost-New"
      value={data.costNew?.toString(true) ?? ''}
      isBold
    />
    <ExportCostApproachDepreciationRows
      data={data}
      hasExternalDepreciation={hasExternalDepreciation}
      hasFunctionalDepreciation={hasFunctionalDepreciation}
    />
    <ExportCostApproachRollupRow
      label="Depreciated Cost Of Improvements"
      value={data.depreciatedCostOfImprovements?.toString(true) ?? ''}
      isBold
    />
    <ExportCostApproachRollupRow
      label='"As-Is" Value of Site Improvements'
      value="Included in site value"
      showEquals={false}
    />
    <ExportCostApproachRollupRow
      label="Indicated Value By Cost Approach"
      value={data.subjectValue?.toString(true) ?? ''}
      isBold
    />
  </View>
);
